import React, { useState, useEffect } from "react";
import SectionTitle from "../SectionTitle";
import Card from "./Card";
import GeneralSummarySkeleton from "./GeneralSummarySkeleton";
import { StyledGeneralSummary } from "./index.styled";
import { getGeneralSummaryCards } from "./utils";
import { useDashboard } from "../../../hooks/useDashboard";

const GeneralSummary: React.FC = () => {
  const {
    overview,
    overviewMonth,
    overviewWeek,
    overviewDay,
    viewsMonth,
    viewsWeek,
    viewsDay,
    loading,
    overviewLoading,
    monthlyLoading,
    weeklyLoading,
    dailyLoading,
  } = useDashboard();
  const [cards, setCards] = useState<ReturnType<typeof getGeneralSummaryCards>>([]);

  // Update cards when data changes
  useEffect(() => {
    const cardsData = getGeneralSummaryCards(
      overview,
      overviewMonth,
      overviewWeek,
      overviewDay,
      viewsMonth,
      viewsWeek,
      viewsDay,
      overviewLoading,
      monthlyLoading,
      weeklyLoading,
      dailyLoading
    );
    setCards(cardsData);
  }, [
    overview,
    overviewMonth,
    overviewWeek,
    overviewDay,
    viewsMonth,
    viewsWeek,
    viewsDay,
    overviewLoading,
    monthlyLoading,
    weeklyLoading,
    dailyLoading,
  ]);

  if (loading) {
    return (
      <>
        <SectionTitle title="סיכום כללי" />
        <GeneralSummarySkeleton />
      </>
    );
  }

  return (
    <>
      <SectionTitle title="סיכום כללי" />
      <StyledGeneralSummary>
        {cards.map((card, index) => (
          <Card key={card.title} card={card} animationDelay={index * 150} />
        ))}
      </StyledGeneralSummary>
    </>
  );
};

export default GeneralSummary;
